<template>
	<div
		ref="dropdownRef"
		class="flex flex-col items-start absolute border border-dg-grey-light bg-white rounded-big px-8 py-10 top-[120%]"
		:style="{ width: width }"
		:class="{
			'left-[50%] translate-x-[-50%]': type == 'center',
			'left-0': type == 'left',
			'right-0': type == 'right',
		}"
	>
		<slot></slot>
	</div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted } from "vue";
import { onClickOutside } from "@vueuse/core";

export default defineComponent({
	name: "BaseDropdown",
	components: {},
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: "400px",
		},
		type: {
			type: String,
			default: "center",
			validator: (value: string) => {
				// valid values
				return ["center", "left", "right"].includes(value);
			},
		},
	},
	setup(props, { emit }) {
		const dropdownRef = ref<HTMLElement | null>(null);
		const translateX = ref(0);

		function setDropdownPosition() {
			const bounding = dropdownRef.value!.getBoundingClientRect() || {};
			const boundingLeft = bounding.left;
			const boundingRight = bounding.right;

			if (boundingLeft < 0) {
				translateX.value = -boundingLeft + 10;
			} else if (boundingRight > window.innerWidth) {
				translateX.value = -(boundingRight - window.innerWidth) - 30;
			}
		}

		onClickOutside(dropdownRef, () => {
			setTimeout(() => {
				props.modelValue == true && emit("update:modelValue", false);
			}, 10);
		});

		onMounted(() => {
			setDropdownPosition();
		});

		return {
			dropdownRef,
			translateX,
		};
	},
});
</script>
